import * as _ from "lodash-es";
import { ParseResult } from "papaparse";
import React, { ChangeEvent, Component } from "react";
import shipstationLogo from "../../../assets/images/shipstation/shipstation-logo-white.png";
import IBulkOrderSubmitDTO from "../../../models/DTO/IBulkOrderSubmitDTO";
import IBulkOrderSubmitProgressDTO from "../../../models/DTO/IBulkOrderSubmitProgressDTO";
import IBulkOrderSubmitStartDTO from "../../../models/DTO/IBulkOrderSubmitStartDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetShipstationCarriersDTO from "../../../models/DTO/IGetShipstationCarriersDTO";
import IGetShipstationPackageTypesForCarrierDTO from "../../../models/DTO/IGetShipstationPackageTypesForCarrierDTO";
import IGetShipstationServicesForCarrierDTO from "../../../models/DTO/IGetShipstationServicesForCarrierDTO";
import IOnBulkOrderSubmitDTO from "../../../models/DTO/IOnBulkOrderSubmitDTO";
import IOnGetShipstationCarriersDTO from "../../../models/DTO/IOnGetShipstationCarriersDTO";
import IOnGetShipstationPackageTypesForCarrierDTO from "../../../models/DTO/IOnGetShipstationPackageTypesForCarrierDTO";
import IOnGetShipstationServicesForCarrierDTO from "../../../models/DTO/IOnGetShipstationServicesForCarrierDTO";
import IOnValidateBulkOrderSubmitDTO from "../../../models/DTO/IOnValidateBulkOrderSubmitDTO";
import IValidateBulkOrderSubmitDTO from "../../../models/DTO/IValidateBulkOrderSubmitDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBulkImportOrderRow from "../../../models/IBulkImportOrderRow";
import IBulkOrderImportRowUI from "../../../models/IBulkOrderImportRowUI";
import IBulkOrderShipDataRow from "../../../models/IBulkOrderShipDataRow";
import IBulkOrderShipDataRowUI from "../../../models/IBulkOrderShipDataRowUI";
import INotification from "../../../models/INotification";
import IOrder_Batch from "../../../models/IOrder_Batch";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IShipstationCarrierDTO from "../../../models/Shipstation/IShipstationCarrierDTO";
import IShipstationPackageTypeDTO from "../../../models/Shipstation/IShipstationPackageTypeDTO";
import IShipstationServiceTypeDTO from "../../../models/Shipstation/IShipstationServiceTypeDTO";
import SocketService from "../../../services/SocketService";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwCsvReader from "../../shared/OwCsvReader/OwCsvReader";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwProgressBar from "../../shared/OwProgressBar/OwProgressBar";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./BulkOrderSubmitModal.scss";
import OwWeightSelector from "../../shared/OwWeightSelector/OwWeightSelector";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import { Socket } from "socket.io-client";
import OwToggle from "@components/shared/OwToggle/OwToggle";

type Props = {
    orderBatch?: IOrder_Batch;
    orderGuids: string[];
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    closeModalFn: (refreshData?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    selectAll: boolean;
};

type State = {
    isProcessing: boolean;
    fileDropRejected: boolean;
    fileTypeRejected: boolean;
    file?: any;
    csvData?: ParseResult<any>;
    shippingOrders: { guid: string; name: string }[];
    hasValidatedGuids: boolean;
    shipstationCarriers: IShipstationCarrierDTO[];
    shipstationPackageTypes: IShipstationPackageTypeDTO[];
    shipstationServiceTypes: IShipstationServiceTypeDTO[];
    submitActive: boolean;
    totalProcessed?: number;
    totalErrors?: number;
    errorDetails?: { message: string }[];
    currentProgress: number;
    currentTotal: number;
    progress: number;
    completed: boolean;
    autoCreatePackages: boolean;
    updateShipstationOrderAddress: boolean;
    activeGetCarriers: boolean;
    activeGetPackageTypes: boolean;
    activeGetServiceTypes: boolean;
    shipstationCarrier: string;
    shipstationServiceType: string;
    shipstationPackageType: string;
    defaultWeight: string;
    shipmentBatchNo: number;
    shipmentBatchToken: string;
    shipstation_bulk_update_accept: string;
};

class BulkOrderSubmitModal extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        let autoCreatePackages = this.props.supplierModel.Supplier_Integration.has_shipstation || false;

        if (this.props.supplierModel.settings.screens?.orders?.bulk_auto_create_shipments) {
            autoCreatePackages = this.props.supplierModel.settings.screens?.orders?.bulk_auto_create_shipments;
        }

        this.state = {
            isProcessing: false,
            fileDropRejected: false,
            fileTypeRejected: false,
            shippingOrders: [],
            hasValidatedGuids: false,
            shipstationCarriers: [],
            shipstationPackageTypes: [],
            shipstationServiceTypes: [],
            submitActive: false,
            currentProgress: 0,
            currentTotal: this.props.orderGuids.length,
            progress: 0,
            completed: false,
            autoCreatePackages,
            updateShipstationOrderAddress: false,
            activeGetCarriers: false,
            activeGetPackageTypes: false,
            activeGetServiceTypes: false,
            shipstationCarrier: "",
            shipstationServiceType: "",
            shipstationPackageType: "",
            defaultWeight: "10",
            shipmentBatchNo: 0,
            shipmentBatchToken: "",
            shipstation_bulk_update_accept: "",
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.OrderEntryOnBulkOrderSubmit, this.onBulkOrderSubmit);
        this.props.socket.on(EndpointsEnum.OrderEntryBulkOrderSubmitStart, this.bulkOrderSubmitStart);
        this.props.socket.on(EndpointsEnum.OrderEntryBulkOrderSubmitProgress, this.bulkOrderSubmitProgress);
        this.props.socket.on(EndpointsEnum.OrderEntryOnValidateBulkOrderSubmit, this.onValidateBulkOrderSubmit);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);

        if (this.props.supplierModel.Supplier_Integration.has_shipstation) {
            this.props.socket.on(EndpointsEnum.ShipstationOnGetCarriers, this.onGetShipstationCarriers);
            this.props.socket.on(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetShipstationServicesForCarrier);
            this.props.socket.on(EndpointsEnum.ShipstationOnGetPackageTypesForCarriers, this.onGetShipstationPackageTypesForCarrier);
        }

        this.validateBulkOrderSubmit();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.OrderEntryOnBulkOrderSubmit, this.onBulkOrderSubmit);
        this.props.socket.removeListener(EndpointsEnum.OrderEntryBulkOrderSubmitStart, this.bulkOrderSubmitStart);
        this.props.socket.removeListener(EndpointsEnum.OrderEntryBulkOrderSubmitProgress, this.bulkOrderSubmitProgress);
        this.props.socket.removeListener(EndpointsEnum.OrderEntryOnValidateBulkOrderSubmit, this.onValidateBulkOrderSubmit);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);

        if (this.props.supplierModel.Supplier_Integration.has_shipstation) {
            this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetCarriers, this.onGetShipstationCarriers);
            this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetShipstationServicesForCarrier);
            this.props.socket.removeListener(
                EndpointsEnum.ShipstationOnGetPackageTypesForCarriers,
                this.onGetShipstationPackageTypesForCarrier
            );
        }
    }

    notify = (notification: INotification) => {
        this.setState({
            submitActive: false,
        });
    };

    /**
     * START SHIPSTATION SPECIFIC FUNCTIONS
     */
    getShipstationCarriers = () => {
        const data: IGetShipstationCarriersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetCarriers, data);

        this.setState({
            activeGetCarriers: true,
        });
    };

    onGetShipstationCarriers = (data: IOnGetShipstationCarriersDTO) => {
        this.setState({
            shipstationCarriers: data.carriers,
            activeGetCarriers: false,
        });
    };

    getShipstationPackageTypesForCarrier = () => {
        const data: IGetShipstationPackageTypesForCarrierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: this.state.shipstationCarrier,
            shipstation_serviceType: this.state.shipstationServiceType,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetPackageTypesForCarriers, data);

        this.setState({
            activeGetPackageTypes: true,
        });
    };

    onGetShipstationPackageTypesForCarrier = (data: IOnGetShipstationPackageTypesForCarrierDTO) => {
        this.setState({
            shipstationPackageTypes: data.packageTypes,
            activeGetPackageTypes: false,
        });
    };

    getShipstationServicesForCarrier = () => {
        const data: IGetShipstationServicesForCarrierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: this.state.shipstationCarrier,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetServicesForCarriers, data);

        this.setState({
            activeGetServiceTypes: true,
        });
    };

    onGetShipstationServicesForCarrier = (data: IOnGetShipstationServicesForCarrierDTO) => {
        const shipstationServiceTypes = data.serviceTypes;

        this.setState({
            shipstationServiceTypes,
            activeGetServiceTypes: false,
        });
    };

    /**
     * END SHIPSTATION SPECIFIC FUNCTIONS
     */

    validateBulkOrderSubmit = () => {
        const payload: IValidateBulkOrderSubmitDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuids: this.props.orderGuids,
        };

        this.props.socket.emit(EndpointsEnum.OrderEntryValidateBulkOrderSubmit, payload);
    };

    onValidateBulkOrderSubmit = (data: IOnValidateBulkOrderSubmitDTO) => {
        const notification: INotification = {
            message: "successfully_validated_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                shippingOrders: data.shippingOrders,
                hasValidatedGuids: true,
            },
            () => {
                if (this.state.shippingOrders.length && this.props.supplierModel.Supplier_Integration.has_shipstation) {
                    this.getShipstationCarriers();
                }
            }
        );
    };

    bulkOrderSubmitStart = (data: IBulkOrderSubmitStartDTO) => {
        this.setState({
            totalProcessed: 0,
            currentProgress: 0,
            completed: false,
            progress: 0,
            currentTotal: data.totalItems,
        });
    };

    bulkOrderSubmitProgress = (data: IBulkOrderSubmitProgressDTO) => {
        const progress = (Number(data.totalProcessed) / Number(data.totalItems)) * 100;

        this.setState({
            currentProgress: data.totalProcessed,
            progress,
        });
    };

    processCsvData = (): string => {
        const csvData = this.state.csvData;

        const rows = csvData?.data.map((dataRow: IBulkOrderShipDataRowUI) => {
            const rowDetail: IBulkOrderShipDataRow = {
                order: dataRow.Order,
                weight: dataRow.Weight,
                width: dataRow.Width,
                height: dataRow.Height,
                length: dataRow.Length,
                guid: dataRow.Guid,
            };

            return rowDetail;
        });

        return JSON.stringify(rows);
    };

    submitBulkOrders = () => {
        const payload: IBulkOrderSubmitDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuids: this.props.orderGuids,
            autoCreatePackages: this.state.autoCreatePackages,
        };

        if (this.state.shipstation_bulk_update_accept === "YES") {
            payload.updateShipstationOrderAddress = this.state.updateShipstationOrderAddress;
        }

        if (this.props.orderBatch) {
            payload.orderBatchGuid = this.props.orderBatch.guid;
        }

        if (this.state.autoCreatePackages) {
            // payload.defaultServiceType = this.state.shipstationServiceType;
            // payload.defaultPackageType = this.state.shipstationPackageType;
            // payload.defaultCarrier = this.state.shipstationCarrier;
            payload.defaultWeight = this.state.defaultWeight;
            payload.shipData = this.processCsvData();
        }

        this.props.socket.emit(EndpointsEnum.OrderEntryBulkOrderSubmit, payload);

        this.setState({
            submitActive: true,
        });
    };

    onBulkOrderSubmit = (data: IOnBulkOrderSubmitDTO) => {
        this.setState({
            completed: true,
            submitActive: false,
            totalProcessed: data.totalProcessed,
            shipmentBatchNo: data.shipmentBatchNo,
            shipmentBatchToken: data.shipmentBatchToken,
            totalErrors: data.totalErrors,
            errorDetails: data.errorDetails,
        });
    };

    closeModal = () => {
        this.props.closeModalFn(true);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = this.state;

        state[name] = value;

        this.setState(state, () => {
            if (name === "shipstationCarrier") {
                this.getShipstationServicesForCarrier();
            } else if (name === "shipstationServiceType") {
                this.getShipstationPackageTypesForCarrier();
            }
        });
    };

    downloadShipDetailsCSV = () => {
        const headerRow = ["Order", "Weight", "Width", "Height", "Length", "Guid"];

        const rows = [headerRow];

        for (const order of this.state.shippingOrders) {
            rows.push([order.name, "", "", "", "", order.guid]);
        }

        const csvContent = "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "orderwerks-bulk-ship-details.csv");

        link.click();
    };

    csvLoaded = (csvData?: ParseResult<any>) => {
        if (csvData) {
            this.setState({ csvData });
        }
    };

    getShipmentBatchUrl = (noPackingList?: boolean): string => {
        const endpointUrl = SocketService.getEndpointUrl();

        let url = `${endpointUrl}/shipstation/batch/labelpack/${this.state.shipmentBatchNo}?token=${this.state.shipmentBatchToken}`;

        if (noPackingList) {
            url += `&inclPackingList=false`;
        }

        return url;
    };

    isFormValid = () => {
        const isValid = true;

        // if (this.props.supplierModel.Supplier_Integration.has_shipstation && this.state.shippingOrders.length) {
        //     if (
        //         !this.state.shipstationCarrier.length ||
        //         !this.state.shipstationPackageType.length ||
        //         !this.state.shipstationServiceType.length
        //     ) {
        //         isValid = false;
        //     }
        // }

        return isValid;
    };

    downloadErrorCsv = () => {
        if (this.state.errorDetails) {
            const headerRow = ["Detail"];

            const dataRows: string[][] = this.state.errorDetails.map((detail) => {
                return [detail.message];
            });

            const rows = [headerRow, ...dataRows];

            const csvContent = "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");

            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "orderwerks-bulk-order-submit-error.csv");

            link.click();
        }
    };

    render() {
        return (
            <div className="BulkOrderSubmitModal standardModal p-2">
                <div className={"w-100 mb-3"}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"bulk_order_submit"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                {this.state.hasValidatedGuids ? null : (
                    <div className={"mb-3"}>
                        <OwLabel title={"validating_orders"} leftIconClass={"fad fa-sync fa-spin"} noBottomMargin={true} />
                    </div>
                )}

                {this.state.shippingOrders.length && !this.state.completed ? (
                    <div>
                        <div className={"mb-3"}>{/** PUT AUTO CREATE SHIPMENTS CHECKBOX HERE */}</div>

                        {this.props.supplierModel.Supplier_Integration.has_shipstation ? (
                            <div className={"mb-3"}>
                                <OwCheckbox
                                    label={"update_shipstation_orders"}
                                    name={"updateShipstationOrderAddress"}
                                    fn={this.handleChange}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={this.state.updateShipstationOrderAddress}
                                />
                                {this.state.updateShipstationOrderAddress ? (
                                    <div>
                                        <div className={"w-100"}>
                                            <OwLabel
                                                title={"bulk_update_shipstation_order_warning"}
                                                className={"text-warning"}
                                                leftIconClass={"fad fa-exclamation-triangle"}
                                            />
                                        </div>
                                        <div className={"col-2 .g-0"}>
                                            <OwInputWrapper
                                                name={"shipstation_bulk_update_accept"}
                                                fn={this.handleChange}
                                                value={this.state.shipstation_bulk_update_accept}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        {this.props.supplierModel.Supplier_Integration.has_shipstation && this.state.autoCreatePackages ? (
                            <div>
                                <div className={"mb-3"}>
                                    {this.props.supplierModel.bulk_shipments_default_weight ? (
                                        <div>
                                            <OwLabel
                                                title={"using_default_bulk_weight"}
                                                postText={":"}
                                                noBottomMargin={true}
                                                className={"me-2"}
                                            />
                                            <OwWeightSelector
                                                onChange={(e: any) => {}}
                                                name={"default"}
                                                disabled={true}
                                                weight={Number(this.props.supplierModel.bulk_shipments_default_weight || 0)}
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <OwButton title={"download_ship_details_csv"} fn={this.downloadShipDetailsCSV} />

                                            <div className={"mt-3"}>
                                                <div className={"drop-area"}>
                                                    <OwCsvReader onFileLoaded={this.csvLoaded} isProcessing={this.state.isProcessing} />
                                                </div>

                                                <div className={"mt-2"}>
                                                    {this.state.file ? (
                                                        <div>
                                                            <OwLabel
                                                                title={"loaded_file"}
                                                                noBottomMargin={true}
                                                                isBold={true}
                                                                isUnderline={true}
                                                            />
                                                            : {this.state.file.name}
                                                        </div>
                                                    ) : null}
                                                    <div className={"d-flex justify-content-between error-section"}>
                                                        <OwLabel
                                                            className={"text-danger mt-2 " + (this.state.fileDropRejected ? "" : "d-none")}
                                                            title={"file_drop_rejected_too_big"}
                                                        />
                                                        <OwLabel
                                                            className={"text-danger mt-2 " + (this.state.fileTypeRejected ? "" : "d-none")}
                                                            title={"file_type_invalid"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/*    <div>*/}
                                {/*        <img src={shipstationLogo} className={"img-fluid"} style={{ height: "1.5rem" }} />*/}
                                {/*    </div>*/}

                                {/*    <OwLabel title={"default_for_shipments"} />*/}

                                {/*    <div className={"mb-2"}>*/}
                                {/*        <OwLabel title={"carrier"} noBottomMargin={true} />*/}
                                {/*        <OwSelectOption*/}
                                {/*            isActive={this.state.activeGetCarriers}*/}
                                {/*            isDisabledOnActive={true}*/}
                                {/*            isDisabled={!this.state.shipstationCarriers.length}*/}
                                {/*            name={"shipstationCarrier"}*/}
                                {/*            valueProp={"code"}*/}
                                {/*            titleProp={"name"}*/}
                                {/*            options={this.state.shipstationCarriers}*/}
                                {/*            selectedOption={this.state}*/}
                                {/*            selectedOptionProp={"shipstationCarrier"}*/}
                                {/*            isRequired={true}*/}
                                {/*            fn={this.handleChange}*/}
                                {/*        />*/}
                                {/*    </div>*/}

                                {/*    <div className={"mb-2"}>*/}
                                {/*        <OwLabel title={"service"} noBottomMargin={true} />*/}
                                {/*        <OwSelectOption*/}
                                {/*            isActive={this.state.activeGetServiceTypes}*/}
                                {/*            isDisabledOnActive={true}*/}
                                {/*            isDisabled={!this.state.shipstationServiceTypes.length}*/}
                                {/*            valueProp={"code"}*/}
                                {/*            titleProp={"name"}*/}
                                {/*            options={this.state.shipstationServiceTypes}*/}
                                {/*            selectedOption={this.state}*/}
                                {/*            selectedOptionProp={"shipstationServiceType"}*/}
                                {/*            name={"shipstationServiceType"}*/}
                                {/*            isRequired={true}*/}
                                {/*            fn={this.handleChange}*/}
                                {/*        />*/}
                                {/*    </div>*/}

                                {/*    <div className={"mb-3"}>*/}
                                {/*        <OwLabel title={"package"} noBottomMargin={true} />*/}
                                {/*        <OwSelectOption*/}
                                {/*            isActive={this.state.activeGetPackageTypes}*/}
                                {/*            isDisabledOnActive={true}*/}
                                {/*            isDisabled={!this.state.shipstationPackageTypes.length}*/}
                                {/*            valueProp={"code"}*/}
                                {/*            titleProp={"name"}*/}
                                {/*            options={this.state.shipstationPackageTypes}*/}
                                {/*            selectedOption={this.state}*/}
                                {/*            selectedOptionProp={"shipstationPackageType"}*/}
                                {/*            name={"shipstationPackageType"}*/}
                                {/*            isRequired={true}*/}
                                {/*            fn={this.handleChange}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                            </div>
                        ) : null}
                    </div>
                ) : null}

                {this.state.hasValidatedGuids ? (
                    <div>
                        <div className={"mb-3"}>
                            <OwToggle
                                name="autoCreatePackages"
                                labelOnRight={true}
                                label="auto_create_shipments"
                                active={this.state.autoCreatePackages}
                                fn={this.handleChange}
                            />
                        </div>
                        <div className={"w-100 mb-3"}>
                            <OwProgressBar
                                title={"progress"}
                                showTitle={true}
                                showTitleChunk={true}
                                currentPercent={this.state.progress}
                                titleChunkCurrent={this.state.currentProgress}
                                titleChunkTotal={this.state.currentTotal}
                            />
                        </div>

                        {this.state.completed ? (
                            <div>
                                <OwLabel title={"results"} noBottomMargin={true} />
                                <div className={"mb-3"}>
                                    <div>
                                        <OwLabel
                                            title={"processed"}
                                            isBold={true}
                                            postText={":"}
                                            className={"me-1"}
                                            noBottomMargin={true}
                                        />
                                        {this.state.totalProcessed}
                                    </div>
                                </div>
                                {this.state.totalErrors ? (
                                    <div className={"mb-3"}>
                                        <div>
                                            <OwLabel
                                                title={"errors"}
                                                isBold={true}
                                                postText={":"}
                                                className={"me-1"}
                                                noBottomMargin={true}
                                            />
                                            {this.state.totalErrors}
                                        </div>
                                        <div className={"mt-2 mb-2"}>
                                            <OwLabel
                                                leftIconClass={"fad fa-download"}
                                                title={"download_error_csv"}
                                                noBottomMargin={true}
                                                fn={this.downloadErrorCsv}
                                            />
                                        </div>
                                        <div>
                                            {this.state.errorDetails?.map((detail, index) => {
                                                return (
                                                    <div key={index} className={"error-detail-message"}>
                                                        {detail.message}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : null}
                                <div>
                                    {this.state.shipmentBatchNo ? (
                                        <div>
                                            <div className={"mb-3"}>
                                                <OwLabel title={"shipment_batch_no"} postText={":"} className={"me-2"} />{" "}
                                                {this.state.shipmentBatchNo}
                                            </div>
                                            <div>
                                                <OwLabel title={"view_batch_pdf"} />
                                            </div>
                                            <div className={"mb-2"}>
                                                <a href={this.getShipmentBatchUrl()} target={"_blank"} rel="noreferrer">
                                                    <OwLabel title={"with_packing_lists"} />
                                                </a>
                                            </div>
                                            <div>
                                                <a href={this.getShipmentBatchUrl(true)} target={"_blank"} rel="noreferrer">
                                                    <OwLabel title={"without_packing_lists"} />
                                                </a>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}

                        <div>
                            <OwButton
                                title={this.state.completed ? "close" : "start"}
                                fn={() => {
                                    if (!this.state.completed) {
                                        this.submitBulkOrders();
                                    } else {
                                        this.closeModal();
                                    }
                                }}
                                disabled={!this.isFormValid()}
                                active={this.state.submitActive}
                                disableOnActive={true}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default BulkOrderSubmitModal;
